import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { initSentry, Sentry } from "@/sentry";
import App from "@/App";

// Backward-compat: collapse accidental "//" in pathname so links generated
// by older builds (where `FRONTEND_URL` had a trailing slash and produced
// e.g. https://rektra.is//verify-email?token=...) still resolve to the
// right React Router route after this deploy. Without this, Safari would
// open the broken URL, React Router would not match `//verify-email`, and
// the user would silently land on the dashboard instead of getting
// verified. Cheap one-liner; runs before App mounts.
(() => {
  try {
    const p = window.location.pathname;
    if (p && p.includes('//')) {
      const cleaned = p.replace(/\/{2,}/g, '/');
      window.history.replaceState(
        window.history.state,
        '',
        cleaned + window.location.search + window.location.hash
      );
    }
  } catch (_) { /* never block render on this */ }
})();

// Initialise Sentry BEFORE React mounts so the global error handler hooks early.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ padding: 24, textAlign: "center" }}>
      <h1>Eitthvað fór úrskeiðis</h1>
      <p>Vinsamlegast hladdu síðunni aftur. Við höfum fengið villuna.</p>
    </div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// Register service worker for PWA — network-first for navigation, cache-first for hashed assets.
// When a new SW is available, prompt the user to reload so they pick up the fresh bundle.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      reg.addEventListener('updatefound', () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener('statechange', () => {
          if (nw.state === 'installed' && navigator.serviceWorker.controller) {
            // New version ready — reload on next navigation so users always see fresh code.
            // Debounced to avoid interrupting something in progress; we use a subtle auto-reload
            // when idle (document hidden) plus a manual confirm if visible.
            const doReload = () => window.location.reload();
            if (document.visibilityState === 'hidden') {
              doReload();
            } else {
              // Show a tiny top-of-page banner. No library — pure DOM so it can't fail.
              const bar = document.createElement('div');
              bar.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;background:#22C55E;color:#fff;padding:10px 16px;text-align:center;font-family:-apple-system,BlinkMacSystemFont,sans-serif;font-size:14px;font-weight:600;box-shadow:0 2px 8px rgba(0,0,0,.2)';
              bar.innerHTML = '<span>Ný útgáfa af Rektra er tilbúin.</span> <button id="rektra-reload" style="margin-left:12px;background:#fff;color:#111;border:0;padding:6px 14px;border-radius:6px;font-weight:700;cursor:pointer">Endurnýja</button>';
              document.body.appendChild(bar);
              document.getElementById('rektra-reload')?.addEventListener('click', doReload);
              // Auto-reload after 30 s if user doesn't act.
              setTimeout(doReload, 30000);
            }
          }
        });
      });
    }).catch(() => {});
  });
}
